export function getTrimmedText(textToTrim, maxLength = 20) {
    if (textToTrim.length > maxLength) {
        return `${textToTrim.substring(0, maxLength)}...`;
    }
    return textToTrim;
}
